import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Styles from '../Styles';
import PropTypes from 'prop-types';
import { Typography, Grid, TablePagination, Table, TableHead, TableRow, TableBody, TableCell, Popover, Button } from '@material-ui/core';
import { Menu, MenuItem, TableContainer } from '@material-ui/core';
import _ from 'lodash';
import { combineStyles } from '../../../Libs/';

const styles = theme => ({
  link: {
    color: '#000',
    textDecoration: 'underline',
    '&:hover': { 
      color: '#000'
    }
  },
  typography: {
    margin: theme.spacing(2)
  },
  stickyHeader: {
    backgroundColor: theme.palette.background.paper,
    position: 'sticky',
    top: 0,
    zIndex: 10,
  },
  stickyFirstColumn: {
    position: 'sticky',
    left: 0,
    zIndex: 11, // un poco mayor que el header
    backgroundColor: 'inherit', // 👈 mantiene el color de fila
  },
  stickyFirstColumnHeader: {
    position: 'sticky',
    left: 0,
    top: 0,
    zIndex: 12, // más alto que el resto del header
    backgroundColor: theme.palette.background.paper,
  }
});


class Visor extends Component {

  state = {
    anchorEl: {},
    menuAnchors: {}
  };

  getTablePagination = () => {
    // ... (sin cambios en paginación)
    if (!this.props.data.count) {
      return null;
    }

    return (
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        className={this.props.classes.tablePagination}
        count={this.props.data.count}
        rowsPerPage={this.props.rowsPerPage}
        page={this.props.page}
        backIconButtonProps={{
          'aria-label': 'Previous Page',
        }}
        nextIconButtonProps={{
          'aria-label': 'Next Page',
        }}
        onPageChange={this.handleChangePage} 
        onRowsPerPageChange={this.handleChangeRowsPerPage}
      />
    );
  };

  handleChangePage = (event, page) => {
    this.props.search(page, this.props.rowsPerPage);
  };

  handleChangeRowsPerPage = (event) => {
    this.props.search(0, event.target.value);
  };

getTableHeader = () => {
  if (!this.props.data.rows.length) return;

  const visibleFields = this.props.fields.filter(field => field.show !== false);

  return visibleFields.map((row, index) => {
    const isFirstColumn = index === 0;
    const cellClass = isFirstColumn
      ? `${this.props.classes.stickyHeader} ${this.props.classes.stickyFirstColumnHeader}`
      : this.props.classes.stickyHeader;

    return (
      <TableCell
        align='left'
        key={100 + index}
        className={cellClass}
      >
        <b>{row.alias}</b>
      </TableCell>
    );
  });
};


  // ... (otros métodos sin cambios)
  formatValue = (value, formatAs) => {
    if (value === null || value === undefined) {
      return '';
    }

    const numValue = parseFloat(value);
    
    if (formatAs === 'currency' && !isNaN(numValue)) {
      return new Intl.NumberFormat('es-CO', { 
        style: 'currency', 
        currency: 'COP', 
        minimumFractionDigits: 0 
      }).format(numValue);
    }
    
    return String(value);
  };
  
  getTableCellStyle = (config, value) => {
    if (!config || !config.conditionalColors) {
      return {};
    }

    for (const rule of config.conditionalColors) {
      let applyColor = false;
      const ruleValue = rule.targetValue;
      const operator = rule.operator;
      const color = rule.color;

      if (rule.type === 'number') {
        const numValue = parseFloat(value);
        if (!isNaN(numValue)) {
          if (operator === '<' && numValue < ruleValue) applyColor = true;
          else if (operator === '>' && numValue > ruleValue) applyColor = true;
          else if (operator === '<=' && numValue <= ruleValue) applyColor = true;
          else if (operator === '>=' && numValue >= ruleValue) applyColor = true;
          else if (operator === '===' && numValue === ruleValue) applyColor = true;
        }
      } 
      else if (rule.type === 'string') {
        const strValue = String(value);
        const normalizedValue = (value === null || value === undefined) ? 'null' : strValue;
        const normalizedTarget = (ruleValue === null || ruleValue === undefined) ? 'null' : String(ruleValue);
        
        if (operator === '===' && normalizedValue === normalizedTarget) applyColor = true;
        else if (operator === '!==' && normalizedValue !== normalizedTarget) applyColor = true;
      }

      if (applyColor) {
        return { backgroundColor: color };
      }
    }

    return {};
  }

  getTableRows = () => {
  const visibleFieldsConfig = this.props.fields.filter(field => field.show !== false);
  const fields = visibleFieldsConfig.map(field => field.name);
  const docFields = {};
  const stateKey = _.find(this.props.fields, { colorize: true });
  this.props.fields.forEach(field => docFields[field.name] = field);

  return this.props.data.rows.map((row, index) => {
    let stateValue = stateKey ? row[stateKey.name] : null;
    const rowStyle = this.getRowStyle(stateValue);

    return (
      <TableRow
        style={rowStyle}
        hover
        key={200 + index}
        className={this.props.classes.tableRow}
      >
        {fields.map((field, idx) => {
          const cellStyle = this.getTableCellStyle(docFields[field], row[field]);
          const isFirstColumn = idx === 0;
          const cellClass = isFirstColumn ? this.props.classes.stickyFirstColumn : '';

          return (
            <TableCell
              key={300 + idx}
              align='left'
              size='small'
              style={cellStyle}
              className={cellClass}
            >
              {this.formatColumnContent(docFields[field], row[field], 500 + index, row)}
            </TableCell>
          );
        })}
      </TableRow>
    );
  });
};

  handleIdClick = (event) => {
    let anchors = this.state.menuAnchors;
    const currentAnchor = event.currentTarget.attributes['aria-owns'].nodeValue;

    anchors[currentAnchor] = event.currentTarget;
    this.setState({
      menuAnchors: anchors
    });
  }

  handlePopClick = (event) => {
    let anchors = this.state.anchorEl;
    const currentAnchor = event.currentTarget.attributes['aria-owns'].nodeValue;

    anchors[currentAnchor] = event.currentTarget;
    this.setState({
      anchorEl: anchors
    });
  }

  handlePopClose = () => {
    let anchors = this.state.anchorEl;
    let menuAnchors = this.state.menuAnchors;
    
    _.each(_.keys(anchors), (key) => {
      anchors[key] = null;
    });
    
    _.each(_.keys(menuAnchors), (key) => {
        menuAnchors[key] = null; 
    });

    this.setState({
      anchorEl: anchors,
      menuAnchors: menuAnchors
    });
  }

  openEditTab = (event) => {
    this.handlePopClose(); 
    window.open(event.currentTarget.attributes['data-url'].nodeValue, '_blank');
  }

    getActionUrl = (config, row) => {

      const nameField = config.nameField;
console.log('ROW COMPLETO:', row);
        switch (config.type) {
          case 'query': {
              const queryParts = [];
              // 🔹 nameField original
              if (nameField && row[nameField] !== undefined) {
                queryParts.push(
                  `${nameField}=${encodeURIComponent(row[nameField])}`
                );
              }
              // 🔹 params adicionales
              if (config.params && typeof config.params === 'object') {
                Object.entries(config.params).forEach(([urlKey, rowField]) => {
                  const value = row[rowField];
                  console.log('urlKey:', urlKey);
                  console.log('rowField:', rowField);
                  console.log('value real:', value);

                  if (value !== undefined) {
                    queryParts.push(
                      `${encodeURIComponent(urlKey)}=${encodeURIComponent(value)}`
                    );
                  }
                });
              }

              return `${config.url}?${queryParts.join('&')}`;
          }

          case 'edit': 
            return `/home/${config?.url ? config.url : this.props.moduleUrl}/${row[nameField]}/edit`;
            
          case 'link': 
            return config.url;
            
          case 'path': 
            return `${config.url}/${row[nameField]}`; 
            
          default:
            console.error(`Tipo de acción de URL no especificado o inválido: ${config.type}`);
            return '#'; 
        }
  }

  getActionMenuItems = (actions, row) => { 
    return actions.map((action, actionIdx) => {
      let isValid = true;
      if (action.when) { 
        _.each(_.keys(action.when), key => {
          if (row[key] !== action.when[key]) {
            isValid = false;
          }
        });
      }

      if (!isValid) {
        return null;
      }
      
      const valueToPass = row[action.nameField]; 

      return (
        <MenuItem 
          key={`action-${actionIdx}`} 
          onClick={this.openEditTab} 
          data-url={this.getActionUrl(action, row)} 
        >
          {action.title}
        </MenuItem>
      );
    });
  }

  formatColumnContent = (config, value, idx, row) => {
    if (!config) {
      return this.formatValue(value, undefined);
    }
    
    const formattedValue = this.formatValue(value, config.formatAs); 

    if (config.actions && config.actions.length > 0) {
      const anchorEl = this.state.menuAnchors[idx];

      return (
        <div>
          <Button
            aria-owns={idx}
            aria-haspopup="true"
            onClick={this.handleIdClick}
          >
            {formattedValue} 
          </Button>
          <Menu
            id={`menu-${idx}`}
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this.handlePopClose}
          >
            {this.getActionMenuItems(config.actions, row)} 
          </Menu>
        </div>
      );

    } else if (config.tooltip) {
      const anchorEl = this.state.anchorEl[idx];
      const open = Boolean(anchorEl);

      return (
        <div>
          <Button
            aria-owns={idx}
            aria-haspopup="true"
            variant="contained"
            onClick={this.handlePopClick}
          >
            Ver
          </Button>
          <Popover
            id={idx}
            open={open}
            anchorEl={anchorEl}
            onClose={this.handlePopClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            transformOrigin={{ vertical: 'top', horizontal: 'center' }}
          >
            <Typography className={this.props.classes.typography}>
              {formattedValue} 
            </Typography>
          </Popover>
        </div>
      );
    } else {
      return formattedValue; 
    }
  }

  getRowStyle = (value) => {
    if (!value) {
      return {};
    }

    if (!this.props.colors || !this.props.colors[value]) {
      return {};
    }

    return {
      backgroundColor: this.props.colors[value]
    };
  };

  render() {
  const { classes, maxHeight } = this.props;

  return (
    <Grid container spacing={8} className={classes.gridResultSearch}>
      <Grid item xs={12}>
      <TableContainer style={{ maxHeight: this.props.maxHeight || '60vh' }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {this.getTableHeader()}
              </TableRow>
            </TableHead>
            <TableBody>
              {this.getTableRows()}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>

      <Grid container alignItems="center">
        <Grid item xs={12}>
          {this.getTablePagination()}
        </Grid>
      </Grid>
    </Grid>
  );
}

}

Visor.propTypes = {
  search: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  fields: PropTypes.array.isRequired,
  filters: PropTypes.object.isRequired,
  colors: PropTypes.object,
  moduleUrl: PropTypes.string.isRequired,
  maxHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default withStyles(combineStyles(styles, Styles), { withTheme: true })(Visor);